import { HTMLAttributes } from 'react';
import {
  FieldNotificationWithLink,
  isFieldNotificationWithLink,
  FieldNotification,
} from '../FieldNotificationWithLink';
import styles from './styles.module.scss';

export type FieldInfomationProps = HTMLAttributes<HTMLUListElement> & {
  /**
   * FieldNotificationWithLinkProps: `{ message: string; url: string; urlText: string; }`
   *
   * FieldNotification: `string | FieldNotificationWithLinkProps`
   */
  info: FieldNotification[];
};

export const FieldInformation = ({ info }: FieldInfomationProps) => (
  <ul className={styles.fieldInformation}>
    {info.map((information) =>
      isFieldNotificationWithLink(information) ? (
        <li key={information.message}>
          <FieldNotificationWithLink
            message={information.message}
            url={information.url}
            urlText={information.urlText}
          />
        </li>
      ) : (
        <li key={information}>{information}</li>
      )
    )}
  </ul>
);

FieldInformation.displayName = 'FieldInformation';
